// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home-side-meun[data-v-de0e00b8]{padding:1rem .5rem;border-radius:.75rem;--bg-opacity:1;background-color:#fefeff;background-color:rgba(254,254,255,var(--bg-opacity));width:240px}.home-side-menu__title[data-v-de0e00b8]{font-size:16px;font-weight:500;margin-left:1.25rem;margin-bottom:.5rem}", ""]);
// Exports
module.exports = exports;
